module.exports = __webpack_public_path__ + "img/organizacion.4fd82ba1.jpg";